import { render, staticRenderFns } from "./ChargesLvl3.vue?vue&type=template&id=1a503b55"
import script from "./ChargesLvl3.vue?vue&type=script&lang=js"
export * from "./ChargesLvl3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports